export function isSignedUp(user) {
  return user.prospects.some(({ invitation_status }) => invitation_status === 'accepted')
}
